/* eslint-disable camelcase */
import * as yup from "yup";

export default t => yup.object().shape({
  newEmail: yup.string().trim()
    .required(t("field_is_required"))
    .email(t("invalid_email_format"))
    .max(1000, "text_too_long"),
  repeatNewEmail: yup.string().trim()
    .required(t("field_is_required"))
    .email(t("invalid_email_format"))
    .max(1000, "text_too_long"),
});
